import React, { useState} from "react";
import { Row, Col, Alert, Container, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CMSLogo from "../../assets/images/long-logo.svg";
import { CircularProgress } from "@material-ui/core";
import { FaHome } from "react-icons/fa";


const Reset = (props) => {
  const [Email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState(null);
  const [loader, setLoader] = useState(false);

  function isValidEmail(email) {
    return /^[\w\.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/.test(email);
  }
  const emailcheck = (e) => {
    if (e.target.value.length > 0) {
      if (!isValidEmail(e.target.value)) {
        setEmailError("Email is invalid");
      } else {
        setEmailError(null);
        setEmail(e.target.value);
      }
    } else {
      setEmailError("Please enter email");
    }
  };

  // handleSubmit
  const handleSubmit = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", Email);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    let loginResponse = await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/password/email`,
      requestOptions
    ).then((response) => {
      return response.text();
    });
    let responseMessage = JSON.parse(loginResponse);
    console.log("here is the Response", responseMessage);
    if (responseMessage?.message) {
      setLoader(false);
      props.history.push("/email-check", {
        messageEmail: responseMessage.message,
        email: responseMessage?.email,
      });
    } else {
      if (responseMessage?.errors) {
        setEmailError(responseMessage?.errors?.email[0]);
        setLoader(false);
      }
    }
  };
  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <FaHome size={32} />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center"></div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-5">
                  <Link to="/" className="mb-2 d-block auth-logo">
                    <img
                      style={{ marginLeft: "auto", marginRight: "auto" }}
                      src={CMSLogo}
                      alt=""
                      height="40"
                      className="logo logo-dark"
                    />
                  </Link>
                  <div className="text-center mt-3">
                    <h5 style={{
                        color: "#000000 !important",
                        fontSize: 15,
                        margin: 0,
                      }}>RESET PASSWORD</h5>
                    <p
                      style={{ color: "#000000 !important" }}
                      className="text-muted"
                    >
                      Please enter your email to reset your password
                    </p>
                  </div>
                  <div className="p-2 mt-4">
                    <AvForm className="form-horizontal">
                      {props.error && typeof props.error === "string" ? (
                        <Alert color="danger">{props.error}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          name="email"
                          label="Email"
                          className="form-control"
                          placeholder="Enter email"
                          onChange={(e) => {
                            emailcheck(e);
                          }}
                        />
                        {EmailError ? (
                          <div
                            style={{
                              fontSize: 12,
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {EmailError}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mt-3">
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          onClick={() => {
                            handleSubmit();
                            setLoader(true);
                          }}
                          disabled={loader}
                        >
                          {loader ? (
                            <CircularProgress
                              size={15}
                              value={100}
                              color={"white"}
                            />
                          ) : (
                            "Reset Submit"
                          )}
                        </button>
                      </div>
                      <div className="mt-3 text-center text-decoration-underline">
                        <Link to="/" className="text-dark">
                          Back to login
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Reset;
